

export default function(){
  // Adapted slightly from Sam Dutton
  // Set name of hidden property and visibility change event
  // since some browsers only offer vendor-prefixed support
  var hidden, state, visibilityChange; 
  if (typeof document.hidden !== "undefined") {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
    state = "visibilityState";
  } else if (typeof document.mozHidden !== "undefined") {
    hidden = "mozHidden";
    visibilityChange = "mozvisibilitychange";
    state = "mozVisibilityState";
  } else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
    state = "msVisibilityState";
  } else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
    state = "webkitVisibilityState";
  }

  let originalTitle = document.title

  // Add a listener that constantly changes the title
  document.addEventListener(visibilityChange, function() {
    if(document[state].toLowerCase().includes('hidden')){
      document.title = `Come back soon! :) `
    }else{
      document.title = originalTitle
    }
  }, false);
}


// WEBPACK FOOTER //
// ./src/components/visibility.js